<template>
    <div class="templates-container">
        <div v-if="$slots.filters" class="filters">
            <slot name="filters" />
        </div>

        <div v-if="items.length === 0 && !isLoading && !error" class="templates-empty-state">
            <slot name="empty" />
        </div>

        <div class="templates">
            <slot v-if="items.length > 0" name="static" />

            <template v-for="item in items">
                <slot name="card" :item="item" />
            </template>

            <template v-if="isLoading">
                <template-gallery-placeholder-card
                    v-for="n in pageSize"
                    :key="`placeholder-${n}`"
                />
            </template>
        </div>

        <scroll-target
            v-if="!isLoading && !isFullyLoaded && !error"
            :root="rootElement"
            @intersect="$emit('fetch')"
        />
    </div>
</template>

<script>
import TemplateGalleryPlaceholderCard from './TemplateGalleryPlaceholderCard';
import ScrollTarget from './ScrollTarget';

export default {
    components: {
        TemplateGalleryPlaceholderCard,
        ScrollTarget,
    },

    props: {
        items: {
            type: Array,
            required: true,
        },
        pageSize: {
            type: Number,
            required: true,
        },
        isLoading: Boolean,
        isFullyLoaded: Boolean,
        error: Error,
    },

    computed: {
        rootElement() {
            return document.getElementById('#content');
        },
    },
};
</script>

<style lang="scss" scoped>
@import './variables';

.templates-container {
    flex: 1;
    padding: $spacing-400;

}

.filters {
    margin-bottom: $spacing-400;
}

.templates {
    display: grid;
    grid-template-columns: repeat(auto-fill, $card-size);
    grid-gap: $spacing-300;
    justify-content: center;

    &> * {
        width: $card-size;
        height: $card-size;
    }
}

.templates-spinner-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
</style>
